import {TimetableService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        timetableOfRoom: undefined
    },

    mutations: {
        saveTimetable(current, timetable) {
            current.timetableOfRoom = {...timetable};
        }
    },

    actions: {
        async getTimetableOfRoomAction({commit}, {schoolYear, semester, begin, end, roomId}) {
            await bindLoading(commit,
                async () => commit('saveTimetable', await TimetableService.getTimetableOfRoom(
                    {schoolYear, semester, begin, end, roomId})), 'timetable');
        }
    }
}